import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useGetSmtpCredentialsQuery, useUpdateCredentialsMutation } from './Api'
import Loader from "../loader/loader";
import toastService from "../../services/toastService";

const EmailSettings = () => {

    const validationSchema = Yup.object().shape({
        providerName: Yup.string()
            .required('Provider name is required')
            .matches(
                /^[A-Za-z.\s]+$/,
                'Provider name can only contain alphabets'
            )
            .min(2, 'Provider name must be at least 2 characters')
            .max(50, 'Provider name cannot exceed 50 characters')
            .trim(),
        fromEmail: Yup.string()
            .required('From Email is required')
            .matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                "Enter valid from email")
            .email('From Email is invalid')
            .trim(),
        smtpHost: Yup.string()
            .required('SMTP host is required')
            .min(2, 'SMTP host must be at least 2 characters')
            .max(50, 'SMTP host cannot exceed 50 characters')
            .trim(),
        smtpPort: Yup.string()
            .required('SMTP port is required')
            .matches(
                /^[0-9]+$/,
                'SMTP port must contain only numbers'
            )
            .min(2, 'SMTP port is invalid')
            .max(5, 'SMTP port is invalid')
            .trim(),
        smtpUsername: Yup.string()
            .required('SMTP username is required')
            .trim(),
        smtpPassword: Yup.string()
            .required('SMTP password is required')
            .min(8, 'SMTP password must be at least 8 characters')
            .max(100, 'SMTP password is too long')
            .trim(),
        encryptionType: Yup.string()
            .required('Encryption type is required')
            .trim(),
        testEmail: Yup.string()
            .notRequired()
            .matches(
                /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                "Enter a valid test email"
            )
            .trim(),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    const { data, isLoading } = useGetSmtpCredentialsQuery()

    const [updateCredentialsApi, { isLoading: updateIsLoading }] = useUpdateCredentialsMutation()


    useEffect(() => {

        if (data?.data) {
            reset({
                providerName: data.data.provider_name,
                fromEmail: data.data.from_email,
                smtpHost: data.data.smtp_host,
                smtpPort: data.data.smtp_port,
                smtpUsername: data.data.smtp_username,
                smtpPassword: data.data.smtp_password,
                encryptionType: data.data.encryption_type,
                testEmail: data.data.test_email || "",
            })
        }

    }, [data])

    const handleOnSubmit = async (data) => {
        try {

            const payload = {
                provider_name: data.providerName,
                from_email: data.fromEmail,
                smtp_host: data.smtpHost,
                smtp_port: Number(data.smtpPort),
                smtp_username: data.smtpUsername,
                smtp_password: data.smtpPassword,
                encryption_type: data.encryptionType,
                test_email: data.testEmail || null,
            }

            const updateApiResponse = await updateCredentialsApi(payload)

            if (updateApiResponse?.data?.success) {
                toastService.success(updateApiResponse.data.message);
            } else {
                toastService.error(updateApiResponse.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <div className="smtp-card">

                    <form onSubmit={handleSubmit(handleOnSubmit)}>
                        <div className="d-flex justify-content-between align-items-center mb-4">

                            <div>
                                <h3 className="fw-bold mb-1">
                                    SMTP Settings
                                </h3>

                                <p className="text-muted mb-0">
                                    Configure your email SMTP credentials
                                </p>
                            </div>

                            <button className="btn btn-primary" type="submit">
                                Save Changes
                            </button>

                        </div>
                        <div className="row">

                            <div className="col-md-6 smtp-field">
                                <label>Provider Name</label>
                                <input type="text"
                                    id="providerName"
                                    name='providerName'
                                    {...register('providerName')}
                                    className="form-control"
                                    placeholder="Enter Provider Name" />
                                {errors.providerName && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.providerName.message}
                                    </p>
                                )}
                            </div>

                            {/* <div className="mb-4">
                                            <input
                                                type="text"
                                                id="mail"
                                                name='email'
                                                placeholder='Email'
                                                {...register('email')}
                                                className="form-control"
                                            />
                                            {errors.email && (
                                                <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.email.message}
                                                </p>
                                            )}
                                        </div> */}

                            <div className="col-md-6 smtp-field">
                                <label>From Email</label>
                                <input type="email"
                                    id="fromEmail"
                                    name='fromEmail'
                                    {...register('fromEmail')}
                                    className="form-control"
                                    placeholder="Enter From Email" />
                                {errors.fromEmail && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.fromEmail.message}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-6 smtp-field">
                                <label>SMTP Host</label>
                                <input type="text"
                                    id="smtpHost"
                                    name='smtpHost'
                                    {...register('smtpHost')}
                                    className="form-control"
                                    placeholder="Enter SMTP Host" />
                                {errors.smtpHost && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.smtpHost.message}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-6 smtp-field">
                                <label>SMTP Port</label>
                                <input type="text"
                                    id="smtpPort"
                                    name='smtpPort'
                                    {...register('smtpPort')}
                                    className="form-control"
                                    placeholder="Enter SMTP Port" />
                                {errors.smtpPort && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.smtpPort.message}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-6 smtp-field">
                                <label>SMTP Username</label>
                                <input type="text"
                                    id="smtpUsername"
                                    name='smtpUsername'
                                    {...register('smtpUsername')}
                                    className="form-control"
                                    placeholder="Enter username" />
                                {errors.smtpUsername && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.smtpUsername.message}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-6 smtp-field">
                                <label>SMTP Password</label>
                                <input type="text"
                                    id="smtpPassword"
                                    name='smtpPassword'
                                    {...register('smtpPassword')}
                                    className="form-control"
                                    placeholder="Enter password" />
                                {errors.smtpPassword && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.smtpPassword.message}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-6 smtp-field">
                                <label>Encryption Type</label>
                                <select
                                    id="encryptionType"
                                    name='encryptionType'
                                    {...register('encryptionType')}
                                    className="form-control"
                                >
                                    <option value="">Select Encryption Type</option>
                                    <option value="TLS">TLS</option>
                                    <option value="SSL">SSL</option>
                                </select>
                                {errors.encryptionType && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.encryptionType.message}
                                    </p>
                                )}
                            </div>

                            {/* <div className="col-md-6 smtp-field smtp-check">
                            <label>
                                <input type="checkbox" />
                                <span>Active SMTP Configuration</span>
                            </label>
                        </div> */}

                            <div className="col-md-6 smtp-field">
                                <label>Test Email</label>
                                <input
                                    type="email"
                                    id="testEmail"
                                    name='testEmail'
                                    {...register('testEmail')}
                                    className="form-control"
                                    placeholder="Enter test email"
                                />
                                {errors.testEmail && (
                                    <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                        {errors.testEmail.message}
                                    </p>
                                )}
                                
                            </div>

                            <div className="smtp-note">
                                <strong>Important:</strong> Before saving SMTP credentials, a test email will be sent to the email address you provide in the Test Email field.
                                The configuration will only be saved if the test email is successfully delivered.
                            </div>

                        </div>

                    </form>

                </div>
            }
        </div>

    );
};

export default EmailSettings;